module.exports = __webpack_public_path__ + "static/img/logo.abf72de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/logo.png
// module id = 9xwl
// module chunks = 7